import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const ArrowRightIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M27.7075 16.7075L18.7075 25.7075C18.5199 25.8951 18.2654 26.0006 18 26.0006C17.7346 26.0006 17.4801 25.8951 17.2925 25.7075C17.1049 25.5199 16.9994 25.2654 16.9994 25C16.9994 24.7346 17.1049 24.4801 17.2925 24.2925L24.5863 17H5C4.73478 17 4.48043 16.8947 4.29289 16.7071C4.10536 16.5196 4 16.2652 4 16C4 15.7348 4.10536 15.4804 4.29289 15.2929C4.48043 15.1054 4.73478 15 5 15H24.5863L17.2925 7.70751C17.1049 7.51987 16.9994 7.26537 16.9994 7.00001C16.9994 6.73464 17.1049 6.48015 17.2925 6.29251C17.4801 6.10487 17.7346 5.99945 18 5.99945C18.2654 5.99945 18.5199 6.10487 18.7075 6.29251L27.7075 15.2925C27.8005 15.3854 27.8742 15.4957 27.9246 15.6171C27.9749 15.7385 28.0008 15.8686 28.0008 16C28.0008 16.1314 27.9749 16.2615 27.9246 16.3829C27.8742 16.5043 27.8005 16.6146 27.7075 16.7075Z" />
  </svg>
);

ArrowRightIcon.propTypes = iconPropTypes;

export default ArrowRightIcon;
